import { Card } from "@/components/ui/card";

export const AccountingReports = () => {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Financial Reports</h3>
      <p className="text-muted-foreground">Reports will appear here.</p>
    </Card>
  );
};